import { FileSummary } from '@savgroup-front-common/types';

const LAST_LEG_HANDLING_DIRECTION = 'ToOwner';

type TrackingNumberEntry = FileSummary['trackingNumbers'][number];

interface LastLegTracking {
  trackingNumber?: string;
  trackingUrl?: string;
  hasTrackingNumber: boolean;
  hasTrackingUrl: boolean;
}

export const getLastLegTracking = (
  trackingNumbers: FileSummary['trackingNumbers'] | undefined,
): LastLegTracking => {
  const lastLegTracking = trackingNumbers
    ?.filter(
      (tracking) => tracking.handlingDirection === LAST_LEG_HANDLING_DIRECTION,
    )
    .reduce<TrackingNumberEntry | undefined>(
      (latest, tracking) =>
        !latest || tracking.wave > latest.wave ? tracking : latest,
      undefined,
    );

  const trackingNumber = lastLegTracking?.trackingNumber || undefined;
  const trackingUrl = lastLegTracking?.trackingUrl || undefined;

  return {
    trackingNumber,
    trackingUrl,
    hasTrackingNumber: !!trackingNumber,
    hasTrackingUrl: !!trackingUrl,
  };
};
